<section class="container py-5 lg:py-8">
  <picture class="col-span-12">
    <source [srcset]="this.section?.desktop" [media]="mediaMediumBreakpoint" />
    <img
      class="mx-auto"
      [src]="this.section?.mobile"
      [alt]="alt"
      loading="lazy"
    />
  </picture>
</section>
